/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAddressV1Dto } from '../models/CreateAddressV1Dto';
import type { CreatePartnerV1Dto } from '../models/CreatePartnerV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { PartnerFilterInnerV2Dto } from '../models/PartnerFilterInnerV2Dto';
import type { PartnerPaginatedV2Dto } from '../models/PartnerPaginatedV2Dto';
import type { PartnerSimplePaginatedV2Dto } from '../models/PartnerSimplePaginatedV2Dto';
import type { PartnerToAddressV1Dto } from '../models/PartnerToAddressV1Dto';
import type { PartnerV1Dto } from '../models/PartnerV1Dto';
import type { PatchPartnerV1Dto } from '../models/PatchPartnerV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnersService {
  /**
   * @param requestBody
   * @returns PartnerV1Dto create entity
   * @throws ApiError
   */
  public static partnerControllerV1CreateV1(
    requestBody: CreatePartnerV1Dto,
  ): CancelablePromise<PartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/partners',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @deprecated
   * @returns PartnerV1Dto a entity list
   * @throws ApiError
   */
  public static partnerControllerV1FindAllV1(): CancelablePromise<Array<PartnerV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partners',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static partnerControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partners',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid partnerId
   * @returns PartnerV1Dto the entity
   * @throws ApiError
   */
  public static partnerControllerV1FindOneV1(uuid: string): CancelablePromise<PartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partners/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid partnerId
   * @param requestBody
   * @returns PartnerV1Dto the update entity
   * @throws ApiError
   */
  public static partnerControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPartnerV1Dto,
  ): CancelablePromise<PartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/partners/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @deprecated
   * @param uuid partnerId
   * @param requestBody
   * @returns PartnerV1Dto the update entity
   * @throws ApiError
   */
  public static partnerControllerV1UpdateV1(
    uuid: string,
    requestBody: PatchPartnerV1Dto,
  ): CancelablePromise<PartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/partners/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid partnerId
   * @returns PartnerV1Dto the entity
   * @throws ApiError
   */
  public static partnerControllerV1RemoveOneV1(uuid: string): CancelablePromise<PartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partners/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid partnerId
   * @returns PartnerV1Dto a entity list
   * @throws ApiError
   */
  public static partnerControllerV1FindManyByAreaIdV1(
    uuid: string,
  ): CancelablePromise<Array<PartnerV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partners/area/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param orderBy Array of PartnerBaseV2Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying Partners
   * @param searchString A search string to filter PartnerBaseV2Dto by given values.
   * @param areaId Filter partners by area ID
   * @returns PartnerPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static partnerControllerV2FindAllPaginatedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: PartnerFilterInnerV2Dto | null,
    searchString?: string | null,
    areaId?: string,
  ): CancelablePromise<PartnerPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/partners',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        areaId: areaId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of PartnerBaseV2Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying Partners
   * @param searchString A search string to filter PartnerBaseV2Dto by given values.
   * @param areaId Filter partners by area ID
   * @returns PartnerSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static partnerControllerV2FindAllSimplePaginatedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: PartnerFilterInnerV2Dto | null,
    searchString?: string | null,
    areaId?: string,
  ): CancelablePromise<PartnerSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/partners/simple',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        areaId: areaId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param partnerUuid partnerId
   * @param requestBody
   * @returns PartnerToAddressV1Dto create entity
   * @throws ApiError
   */
  public static partnerToAddressControllerV1CreateAddressV1(
    partnerUuid: string,
    requestBody: CreateAddressV1Dto,
  ): CancelablePromise<PartnerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/partners/{partnerUuid}/address',
      path: {
        partnerUuid: partnerUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param partnerUuid partnerId
   * @param addressUuid addressId
   * @returns PartnerToAddressV1Dto create entity
   * @throws ApiError
   */
  public static partnerToAddressControllerV1LinkAddressV1(
    partnerUuid: string,
    addressUuid: string,
  ): CancelablePromise<PartnerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/partners/{partnerUuid}/address/{addressUuid}',
      path: {
        partnerUuid: partnerUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param partnerUuid partnerId
   * @param addressUuid addressId
   * @returns PartnerToAddressV1Dto the entity
   * @throws ApiError
   */
  public static partnerToAddressControllerV1UnlinkAddressV1(
    partnerUuid: string,
    addressUuid: string,
  ): CancelablePromise<PartnerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partners/{partnerUuid}/address/{addressUuid}',
      path: {
        partnerUuid: partnerUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param partnerUuid partnerId
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static partnerToAddressControllerV1RemoveManyAddressesV1(
    partnerUuid: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partners/{partnerUuid}/addresses',
      path: {
        partnerUuid: partnerUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
